import Vue from 'vue'
import axios from 'axios'

import '@/assets/css/tailwind.css'

import App from './App.vue'
import router from './router'
import store from '../store/'

Vue.config.productionTip = false
Vue.prototype.$axios = axios

axios.defaults.baseURL = process.env.NODE_ENV === 'development'
  ? 'http://localhost:3000'
  : 'https://production.aide-api.seniormedia.fr'

// auto inject jwt
axios.interceptors.request.use(
  req => {
    if (store.getters['auth/isAuthenticated']) {
      req.headers['Authorization'] = `Bearer ${store.state.auth.jwt}`
    }

    return req
  },
  err => Promise.reject(err)
)

// handle 401
axios.interceptors.response.use(
  res => res,
  err => {
    if (err.response.status === 401) {
      store.commit('auth/SET_TOKEN', null)
      router.push('/connexion')
    }
  }
)

// load jwt from local storage
if (JSON.parse(localStorage.getItem('jwt'))) {
  store.commit('auth/SET_TOKEN', JSON.parse(localStorage.getItem('jwt')))
} else {
  router.push('/connexion')
}

// layouts
Vue.component('Login', () => import(/* webpackChunkName: "LayoutLogin" */ '@/layouts/Login'))
Vue.component('Default', () => import(/* webpackChunkName: "LayoutDefault" */ '@/layouts/Default'))

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
